import Layout from "../../hocs/Layout";
import { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  get_paises,
  get_provincias,
  get_municipios,
  get_poblaciones,
  get_tipovia,
  get_distribuidoras_gas,
  get_cnaes,
} from "../../redux/actions/auxiliares";
import { get_partner_by_id, get_partner_by_vat } from "../../services/partner";
import { setLoader, removeLoader } from "../../redux/actions/loader";
import {
  find_or_create_cups,
  get_cups,
  set_cups_erp,
  generar_precios,
  btn_import_sips,
  btn_search_sips,
} from "../../services/cups";
import { get_datos_oferta_erp, set_oferta_erp, clear_oferta_cups_erp } from "../../services/ofertas";
import { toast } from "react-toastify";
import { getDistribuidoras } from "../../services/auxiliares";
import {
  Button,
  Col,
  Form,
  Row,
  Card,
  FloatingLabel,
  Container,
} from "react-bootstrap";
import { TextInput, SelectInput } from "../../components/inputs/Inputs";
import { AddressFields } from "../../components/inputs/AddressFields";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { cupsSchema } from "../../utils/validationSchemas";
import { autoconsumos } from "../../utils/constants/autoconsumos";
import { CODIGOS_TARIFA_ATR } from "../../utils/constants/tarifas";
import PotenciasInput from "../../components/inputs/PotenciasInput";
import { includesBvLabel } from "../../utils/bateriaVirtual";
import { hasAddressData, shouldAutoUseClientAddress, addressesMatch } from "../../utils/ofertaCupsAddressUtils";
import {
  normalizeCupsForSearch,
  shouldLockFieldByValueAndDirty,
  hasMissingRequiredAddressFields,
} from "../../utils/ofertaCupsBehavior";
import OfferWizardWrapper from "../../components/ofertas/OfferWizardWrapper";
import { useOfferWizard } from "../../components/ofertas/OfferWizardContext";

import "./OfertasList.css";

const OfertaCupsForm = ({
  setLoader,
  removeLoader,
  paises,
  provincias,
  municipios,
  poblaciones,
  tipovia,
  distribuidorasGas,
  cnaes,
  get_paises,
  get_provincias,
  get_municipios,
  get_poblaciones,
  get_tipovia,
  get_distribuidoras_gas,
  get_cnaes,
}) => {

  const [suggestions, setSuggestions] = useState([]);
  const getSuggestions = (value) => {
    const filtrar = cnaes.filter(c => {
      const name = c.name || "";
      return (name.startsWith(value || ""));
    });

    setSuggestions(filtrar);
  };

  const elegirSuggestio = (cnae) => {
    setValue("cnae", cnae.name);
    setValue("cnae_desc", cnae.descripcio);
    setSuggestions([]); //cerrar desplegable
  };

  const extractSubtypeText = (value) => {
    if (Array.isArray(value)) {
      if (value.length > 1) return String(value[1] || value[0] || "");
      return String(value[0] || "");
    }
    if (value && typeof value === "object") {
      return String(value.name || value.display_name || value.label || value.value || value.id || "");
    }
    return String(value || "");
  };

  const normalizeSubTypeOffer = (value) =>
    extractSubtypeText(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");

  const isSubtypePrefix = (value, ...prefixes) => {
    const normalized = normalizeSubTypeOffer(value);
    return prefixes.some((prefix) => normalized.startsWith(prefix));
  };

  const isCambioComercializadoraSubtype = (value) => {
    const normalized = normalizeSubTypeOffer(value);
    return (
      normalized.startsWith("cambio_comercializador")
      || normalized.startsWith("cambio_de_comercializador")
      || normalized.startsWith("cambio_comerc")
      || (normalized.startsWith("cambio") && (
        normalized.includes("comercializador") || normalized.includes("comerc")
      ))
    );
  };

  const isCambioTitularSubtype = (value) => {
    const normalized = normalizeSubTypeOffer(value);
    return (
      normalized.startsWith("cambio_titular")
      || normalized.startsWith("cambio_de_titular")
      || (normalized.startsWith("cambio") && normalized.includes("titular"))
    );
  };

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const sector_type = params.sector_type;
  const [editMode, setEditMode] = useState(false);
  const [oferta_erp, setOfertaErp] = useState(null);
  const [loadingProv, setLoadingProv] = useState(false);
  const [loadingMuni, setLoadingMuni] = useState(false);
  const [loadingPob, setLoadingPob] = useState(false);
  const [cups, setCups] = useState(false);
  const [isCupsInErp, setIsCupsInErp] = useState(false);
  const [useClientAddress, setUseClientAddress] = useState(false);
  const [clientAddress, setClientAddress] = useState(null);
  const [type, setType] = useState(" ");
  const [sipsWarning, setSipsWarning] = useState(null);
  const [activeContractWarning, setActiveContractWarning] = useState(null);
  const [sipsTechnicalData, setSipsTechnicalData] = useState(null);
  const [sipsTarifaAcceso, setSipsTarifaAcceso] = useState(null);
  const [sipsBusinessWarnings, setSipsBusinessWarnings] = useState([]);
  const [sipsGasTechnicalData, setSipsGasTechnicalData] = useState(null);
  const [gasDistribuidoraSource, setGasDistribuidoraSource] = useState("none");
  const [autoconsumoFallbackOption, setAutoconsumoFallbackOption] = useState(null);
  const [refCatastralReadOnly, setRefCatastralReadOnly] = useState(false);
  const [isSearchingCups, setIsSearchingCups] = useState(false);
  const [isSipsNotFoundAfterSearch, setIsSipsNotFoundAfterSearch] = useState(false);
  const [sipsCnaeValid, setSipsCnaeValid] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [addressLoadError, setAddressLoadError] = useState(null);
  const [partnerAddressLoaded, setPartnerAddressLoaded] = useState(false); // Flag to prevent duplicate loading
  const [addressPrefillLabels, setAddressPrefillLabels] = useState({
    provincia: "",
    municipio: "",
    poblacion: "",
    tipoVia: "",
  });
  // Campos de dirección bloqueados por venir precargados (ERP/SIPS/cliente/oferta guardada).
  // Se recalcula explícitamente en loadAddressIntoForm/clearAddressFields; no depende de "dirty".
  const [lockedAddressFields, setLockedAddressFields] = useState({});
  const distribuidoraRequestRef = useRef(null);
  const pendingGasDistribuidoraRef = useRef(null);
  const initialSipsLoadRef = useRef(false);
  const initialErpCupsCheckRef = useRef(false);
  const erpCupsAddressRef = useRef(null);
  const regexpPotencia = /^[0-9]+,*([0-9])*$/;

  const matchDistribuidoraFromSips = (sipsName, distribuidoras) => {
    if (!sipsName || !distribuidoras?.length) return null;
    const sipsNorm = sipsName.toLowerCase().trim();
    for (const dist of distribuidoras) {
      if (!dist.name || dist.id === 0) continue;
      const distNorm = dist.name.toLowerCase();
      if (distNorm === sipsNorm || distNorm.includes(sipsNorm) || sipsNorm.includes(distNorm)) return dist;
    }
    const stopWords = new Set(['sa', 'sl', 'slu', 'sau', 'spa', 'de', 'del', 'la', 'el', 'gas', 'energia', 'energía', 'distribución', 'distribucion', 'españa', 'spain']);
    const sipsWords = sipsNorm.split(/[\s,./\-]+/).map(w => w.replace(/[()]/g, '')).filter(w => w.length > 3 && !stopWords.has(w));
    if (!sipsWords.length) return null;
    let bestMatch = null; let bestScore = 0;
    for (const dist of distribuidoras) {
      if (!dist.name || dist.id === 0) continue;
      const score = sipsWords.filter(w => dist.name.toLowerCase().includes(w)).length;
      if (score > bestScore) { bestScore = score; bestMatch = dist; }
    }
    return bestScore > 0 ? bestMatch : null;
  };

  const getFirstElement = (value) =>
    Array.isArray(value) && value.length > 0
      ? value[0]
      : value && typeof value === "object" && value.id !== undefined
        ? value.id
        : value;

  const getIdAndName = (value) => {
    if (Array.isArray(value)) {
      return {
        id: value.length > 0 ? value[0] : "",
        name: value.length > 1 ? value[1] : "",
      };
    }
    if (value && typeof value === "object") {
      return {
        id: value.id !== undefined ? value.id : "",
        name: value.name || value.display_name || "",
      };
    }
    return { id: value, name: "" };
  };

  const resolveGasDistribuidoraFromSource = useCallback((source) => {
    if (!source) return null;

    const m2oCandidates = [
      source.cups_gas_distribuidora_id,
      source.gas_distribuidora_id,
      source.cups_distribuidora_id,
      source.distribuidora_id,
    ];

    for (const candidate of m2oCandidates) {
      const { id, name } = getIdAndName(candidate);
      if (id !== null && id !== undefined && id !== "") {
        const byId = distribuidorasGas?.find((d) => String(d?.id) === String(id));
        return {
          id,
          name: name || byId?.name || "",
        };
      }
    }

    const nameCandidate =
      source.cups_gas_distribuidora_name ||
      source.cups_distribuidora_name ||
      source.nombreEmpresaDistribuidora ||
      "";

    if (!nameCandidate) return null;

    const matched = matchDistribuidoraFromSips(nameCandidate, distribuidorasGas || []);
    if (matched) {
      return { id: matched.id, name: matched.name };
    }
    return { id: "", name: String(nameCandidate) };
  }, [distribuidorasGas]);

  const hasOptionById = (items, id) => {
    if (!items?.length || id === null || id === undefined || id === "") return false;
    const idStr = String(id);
    return items.some((it) => String(it?.id) === idStr);
  };

  const fallbackAddressOptionLabel = (label, id, kind) => {
    if (label && String(label).trim() !== "") return label;
    if (id === null || id === undefined || id === "") return "";
    return `${kind} (${id})`;
  };

  const getVisibleAddressLabel = (items, id, fallbackLabel, kind) => {
    if (id === null || id === undefined || id === "") return "";
    const found = items?.find((it) => String(it?.id) === String(id));
    return found?.name || fallbackAddressOptionLabel(fallbackLabel, id, kind);
  };
  const toNumericId = (value) => {
    const raw = getFirstElement(value);
    if (raw === null || raw === undefined || raw === "" || raw === false) return "";
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? raw : parsed;
  };

  const getSipsValue = (source, keys) => {
    if (!source) return "";
    for (const key of keys) {
      const value = source?.[key];
      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }
    return "";
  };

  const resolveCupsRefCatastral = (source) => {
    //El paquet cupsData es qui porta el valor ref_catastral
    return source?.cups_ref_catastral || source?.ref_catastral || "";
  };

  const markRefCatastralAsPreloaded = (value) => {
    if (String(value ?? "").trim() !== "") {
      setRefCatastralReadOnly(true);
    }
  };

  const normalizeAutoconsumoValue = (value) => {
    const optionIds = new Set(autoconsumos.map((option) => String(option.id).trim().toUpperCase()));
    const optionNames = new Map(
      autoconsumos.map((option) => [String(option.name).trim().toUpperCase(), String(option.id)])
    );

    const extractCandidate = (candidate) => {
      if (candidate === null || candidate === undefined || candidate === "") {
        return "";
      }
      if (Array.isArray(candidate)) {
        return extractCandidate(candidate[0] ?? candidate[1]);
      }
      if (typeof candidate === "object") {
        return extractCandidate(
          candidate.id ?? candidate.code ?? candidate.value ?? candidate.name ?? candidate.display_name
        );
      }
      return String(candidate).trim();
    };

    const rawValue = extractCandidate(value);
    if (!rawValue) {
      return { selectValue: "", fallbackOption: null };
    }

    const normalizedValue = rawValue.toUpperCase().replace(/\s+/g, "");
    if (optionIds.has(normalizedValue)) {
      return { selectValue: normalizedValue, fallbackOption: null };
    }

    const paddedNumericValue = normalizedValue.padStart(2, "0");
    if (/^\d+$/.test(normalizedValue) && optionIds.has(paddedNumericValue)) {
      return { selectValue: paddedNumericValue, fallbackOption: null };
    }

    const normalizedByName = optionNames.get(rawValue.toUpperCase());
    if (normalizedByName) {
      return { selectValue: normalizedByName, fallbackOption: null };
    }

    return {
      selectValue: normalizedValue,
      fallbackOption: {
        id: normalizedValue,
        name: `Valor ERP/SIPS (${rawValue})`,
      },
    };
  };

  const resolveAutoconsumoFromSource = (source) => {
    if (!source || typeof source !== "object") return "";

    return (
      source.autoconsumo_id ??
      source.autoconsumo ??
      source.tipoAutoconsumo ??
      source.tipo_autoconsumo ??
      source.codigoAutoconsumo ??
      source.codigo_autoconsumo ??
      ""
    );
  };

  const applyAutoconsumoValue = (sourceValue, options = {}) => {
    const { preserveCurrentOnEmpty = false, fallbackValue = undefined } = options;
    const { selectValue, fallbackOption } = normalizeAutoconsumoValue(sourceValue);

    if (!selectValue && preserveCurrentOnEmpty) {
      const fallback = fallbackValue !== undefined ? fallbackValue : getValues("autoconsumo_id");
      const normalizedFallback = normalizeAutoconsumoValue(fallback);
      if (!normalizedFallback.selectValue) {
        return;
      }

      setAutoconsumoFallbackOption(normalizedFallback.fallbackOption);
      setValue("autoconsumo_id", normalizedFallback.selectValue, { shouldValidate: false });
      return;
    }

    setAutoconsumoFallbackOption(fallbackOption);
    setValue("autoconsumo_id", selectValue, { shouldValidate: false });
  };

  const buildSipsGasTechnicalData = (source) => ({
    caudal_horario: getSipsValue(source, ["caudalHorarioEnWh", "caudal_horario"]),
    caudal_maximo_diario: getSipsValue(source, ["caudalMaximoDiarioEnWh", "caudal_maximo_diario"]),
    codigo_presion: getSipsValue(source, ["codigoPresion", "codigo_presion"]),
  });

  const buildSipsTechnicalData = (source) => ({
    potencia_maxima_bie: getSipsValue(source, ["potencia_maxima_bie", "potenciaMaximaBIE", "potenciaMaximaBie"]),
    fecha_caducidad_bie: getSipsValue(source, ["fecha_caducidad_bie", "fechaCaducidadBIE", "fechaCaducidadBie"]),
    valor_derechos_extension: getSipsValue(source, ["valor_derechos_extension", "valorDerechosExtension", "derechosExtension"]),
    tipo_autoconsumo_sips: getSipsValue(source, ["tipo_autoconsumo_sips", "tipoAutoconsumo", "tipo_autoconsumo", "codigoAutoconsumo"]),
    aplicacion_bono_social_sips: getSipsValue(source, ["aplicacion_bono_social_sips", "aplicacionBonoSocial", "aplicaBonoSocial", "bonoSocial"]),
    tipo_perfil_consumo_sips: getSipsValue(source, ["tipo_perfil_consumo_sips", "tipoPerfilConsumo", "perfilConsumo", "perfil_de_consumo"]),
  });

  const hasAnyTechnicalSipsValue = (technicalData) => {
    if (!technicalData) return false;
    return [
      technicalData.potencia_maxima_bie,
      technicalData.fecha_caducidad_bie,
      technicalData.valor_derechos_extension,
      technicalData.tipo_autoconsumo_sips,
      technicalData.aplicacion_bono_social_sips,
      technicalData.tipo_perfil_consumo_sips,
    ].some((val) => val !== undefined && val !== null && String(val).trim() !== "");
  };

  const resolveSipsTechnicalData = (primaryPayload, secondaryPayload = null) => {
    const candidateSources = [
      primaryPayload,
      secondaryPayload,
      primaryPayload?.cups,
      secondaryPayload?.cups,
      primaryPayload?.sips,
      secondaryPayload?.sips,
      primaryPayload?.sips_data,
      secondaryPayload?.sips_data,
    ].filter(Boolean);

    for (const candidate of candidateSources) {
      const technical = buildSipsTechnicalData(candidate);
      if (hasAnyTechnicalSipsValue(technical)) {
        return technical;
      }
    }

    return null;
  };

  const normalizeBooleanLike = (value) => {
    if (typeof value === "boolean") return value;
    if (value === null || value === undefined) return false;
    const normalized = String(value).trim().toLowerCase();
    return ["1", "true", "si", "sí", "yes", "y"].includes(normalized);
  };

  const buildSipsBusinessWarnings = (technicalData) => {
    const warnings = [];
    const offerAutoconsumo = String(oferta_erp?.autoconsumo ?? "").trim();
    const sipsAutoconsumo = String(technicalData?.tipo_autoconsumo_sips ?? "").trim();

    if (sipsAutoconsumo && offerAutoconsumo && sipsAutoconsumo !== offerAutoconsumo) {
      warnings.push(
        `Tipo de autoconsumo SIPS (${sipsAutoconsumo}) distinto al de la oferta (${offerAutoconsumo}). Revise antes de continuar.`
      );
    }

    if (normalizeBooleanLike(technicalData?.aplicacion_bono_social_sips)) {
      warnings.push(
        "SIPS informa posible aplicación de Bono Social. Verifique condición contractual y documentación requerida."
      );
    }

    return warnings;
  };

  const normalizeTarifaAcceso = (value) => {
    // Resolve numeric ATR code (e.g. "018") to its name ("2.0TD") first
    const resolved = CODIGOS_TARIFA_ATR[String(value || "").trim()] || value;
    const normalized = String(resolved || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(",", ".");

    // Some SIPS responses include profile prefix (e.g. P2.0TD).
    if (/^P\d/.test(normalized)) {
      return normalized.substring(1);
    }
    return normalized;
  };

  const areTarifasAccesoCompatible = (sipsTarifa, selectedTarifa) => {
    const sipsNormalized = normalizeTarifaAcceso(sipsTarifa);
    const selectedNormalized = normalizeTarifaAcceso(selectedTarifa);

    if (!sipsNormalized || !selectedNormalized) return true;
    return sipsNormalized === selectedNormalized;
  };

  const resolveTarifaAccesoSips = (source) =>
    getSipsValue(source, [
      "tarifa_acceso_sips",       // clave normalizada por backend
      "codigoTarifaATREnVigor",   // campo real SIPS eléctrico
      "codigo_tarifa_atr_en_vigor",
      "tipoPerfilConsumo",
      "tipo_perfil_consumo",
      "codigoPeajeEnVigor",
      "codigo_peaje_en_vigor",
      "tarifaAccesoSips",
      "tarifaAcceso",
      "tarifa_acceso",
      "peaje",
      "peaje_sips",
    ]);

  const hydrateSipsTechnicalState = useCallback((sipsPayload, importedPayload = null) => {
    const technicalData = resolveSipsTechnicalData(sipsPayload, importedPayload);
    if (technicalData) {
      setSipsTechnicalData(technicalData);
      setSipsBusinessWarnings(buildSipsBusinessWarnings(technicalData));
    } else {
      setSipsTechnicalData(null);
      setSipsBusinessWarnings([]);
    }

    const peajeSips =
      resolveTarifaAccesoSips(importedPayload) ||
      resolveTarifaAccesoSips(sipsPayload);

    if (peajeSips) {
      setSipsTarifaAcceso(peajeSips);
    }
  }, [resolveSipsTechnicalData, buildSipsBusinessWarnings, resolveTarifaAccesoSips]);

  const isAltaNuevo = isSubtypePrefix(oferta_erp?.sub_type_offer, "alta_nuevo", "alta_nuevo_suministro");
  const isCambioComercializadora = isCambioComercializadoraSubtype(oferta_erp?.sub_type_offer);
  const isAnyCambioTitularSubtype = isCambioTitularSubtype(oferta_erp?.sub_type_offer);
  const isCambioTitular =
    isAnyCambioTitularSubtype
    && !isCambioComercializadora;
  const isRenewalSubtype =
    isSubtypePrefix(oferta_erp?.sub_type_offer, "renovacion") || type === "renovacion";
  const isAutoconsumoChangeSubtype = normalizeSubTypeOffer(oferta_erp?.sub_type_offer).includes("autoconsum")
    || normalizeSubTypeOffer(oferta_erp?.sub_type_offer) === "cambio_completo";

  useEffect(() => {
    if (sector_type !== "electrico") {
      setSipsWarning(null);
      return;
    }

    const selectedTarifaOferta = oferta_erp?.tarifa_oferta?.[1];
    if (!selectedTarifaOferta || !sipsTarifaAcceso) {
      setSipsWarning(null);
      return;
    }

    const mismatch = !areTarifasAccesoCompatible(sipsTarifaAcceso, selectedTarifaOferta);
    if (mismatch) {
      const sipsTarifaNombre = CODIGOS_TARIFA_ATR[sipsTarifaAcceso] || sipsTarifaAcceso;
      setSipsWarning(
        `La tarifa de acceso obtenida de SIPS (${sipsTarifaNombre}) no coincide con la tarifa seleccionada en la oferta (${selectedTarifaOferta}). Revise el paso de Tarifa y Condiciones.`
      );
    } else {
      setSipsWarning(null);
    }
  }, [sector_type, oferta_erp?.tarifa_oferta, sipsTarifaAcceso]);

  // Un camp es considera "tocat" per l'usuari si react-hook-form el marca dirty;
  // els valors que arriben via setValue(..., { shouldDirty: false }) (ERP/SIPS/cliente) no ho estan.
  const isFieldDirty = (name) => {
    const segments = String(name || "").split(".");
    let cursor = dirtyFields;
    for (const segment of segments) {
      if (!cursor || typeof cursor !== "object") return false;
      cursor = cursor[segment];
    }
    return !!cursor;
  };

  const shouldLockCurrentValue = (name, value) => {
    // Lock values coming from ERP/SIPS, but keep fields editable once the user starts typing.
    return shouldLockFieldByValueAndDirty(value, isFieldDirty(name));
  };

  const lockOnlyIfFilled = (name) => {
    const currentValue = getValues(name);
    return shouldLockCurrentValue(name, currentValue);
  };

  // Bloqueo de los campos de dirección campo a campo: si ya trae valor precargado
  // queda en solo lectura; si viene vacío, editable. Se basa en el estado explícito
  // `lockedAddressFields` (actualizado por loadAddressIntoForm/clearAddressFields),
  // no en heurísticas de "dirty" ni en el subtipo de oferta.
  const isAddressFieldReadOnly = (fieldName) => {
    if (useClientAddress) return true;
    return !!lockedAddressFields[fieldName];
  };

  const isFieldReadOnly = (fieldName) => {
    if (!oferta_erp) return false;
    const subType = oferta_erp.sub_type_offer;
    const normalizedSubType = normalizeSubTypeOffer(subType);
    const isCambioComercializadoraCurrent = isCambioComercializadoraSubtype(subType);
    const isCambioTitularCurrent =
      isCambioTitularSubtype(subType)
      && !isCambioComercializadoraCurrent;
    const isRenovacionSubtype = isSubtypePrefix(subType, "renovacion");

    const hasExternalDataLock = isCupsInErp || cups;

    // Si tras buscar en SIPS no se encuentra el CUPS y tampoco está en ERP,
    // permitir edición manual de los campos para completar el suministro.
    if (isSipsNotFoundAfterSearch && !isCupsInErp) {
      return false;
    }

    // Gas: distribuidora is only locked when it comes from ERP CUPS search.
    if (
      sector_type === "gas" &&
      (fieldName === "cups_distribuidora_id" || fieldName === "cups_distribuidora_name")
    ) {
      if (isAltaNuevo) {
        return false;
      }
      const distId = getValues("cups_distribuidora_id");
      const distName = getValues("cups_distribuidora_name");
      // For renovación/cambio titular: keep value immutable if already filled.
      if (isRenovacionSubtype || isCambioTitularCurrent) {
        return shouldLockCurrentValue("cups_distribuidora_id", distId)
          || shouldLockCurrentValue("cups_distribuidora_name", distName);
      }
      // Cambio de comercializadora: bloquear si ya existe valor en distribuidora.
      if (isCambioComercializadoraCurrent) {
        return shouldLockCurrentValue("cups_distribuidora_id", distId)
          || shouldLockCurrentValue("cups_distribuidora_name", distName);
      }
      return gasDistribuidoraSource === "erp" && (
        shouldLockCurrentValue("cups_distribuidora_id", distId)
        || shouldLockCurrentValue("cups_distribuidora_name", distName)
      );
    }

    // Alta Nuevo: Totalmente editable
    if (isSubtypePrefix(subType, "alta_nuevo", "alta_nuevo_suministro")) return false;

    if (fieldName === "autoconsumo_id" && isAutoconsumoChangeSubtype) {
      return false;
    }

    // Campos técnicos comunes a bloquear
    const technicalFields = [
      "consumo_anual_previsto",
      "autoconsumo_id",
      "cups_distribuidora_id",
      "cups_distribuidora_name",
      "cnae",
      "potencias"
    ];

    const subtypeAllowsField = (name) => {
      if (!name) return false;
      return normalizedSubType.includes(name);
    };

    // Lógica para Cambio de Comercializadora
    if (isCambioComercializadoraCurrent) {
      if (hasExternalDataLock) {
        const allowed = [];
        const isCompleteSubtype = normalizedSubType.includes("completo") || normalizedSubType.includes("completa");
        if (normalizedSubType.includes("potencia") || isCompleteSubtype) allowed.push("potencias");
        if (normalizedSubType.includes("autoconsumo") || isCompleteSubtype) allowed.push("autoconsumo_id");

        if (fieldName === "cnae") {
          const currentValue = getValues("cnae");
          return shouldLockCurrentValue("cnae", currentValue);
        }

        if (technicalFields.includes(fieldName)) {
          if (allowed.includes(fieldName)) {
            return false;
          }
          return lockOnlyIfFilled(fieldName);
        }
        if (fieldName.startsWith("potencias.")) {
          if (allowed.includes("potencias")) {
            return false;
          }
          return lockOnlyIfFilled(fieldName);
        }
      }
      return false;
    }

    // Lógica para Cambio de Titular
    if (isCambioTitularCurrent) {
      const allowedFields = [];
      if (normalizedSubType.includes("potencia")) allowedFields.push("potencias");
      if (normalizedSubType.includes("autoconsumo")) allowedFields.push("autoconsumo_id");

      if (fieldName.startsWith("potencias.")) {
        return !allowedFields.includes("potencias");
      }

      if (technicalFields.includes(fieldName)) {
        if (allowedFields.includes(fieldName)) {
          return false;
        }
        return lockOnlyIfFilled(fieldName);
      }

      if (fieldName.startsWith("cups_")) {
        // En cambio de titular mantenemos bloqueados los valores existentes,
        // pero permitimos completar los campos que lleguen vacíos.
        return lockOnlyIfFilled(fieldName);
      }

      return false;
    }

    // Lógica para Renovación
    if (isRenovacionSubtype) {
      const isCompleteSubtype = normalizedSubType.includes("completo") || normalizedSubType.includes("completa");
      const isTarifaRenewalSubtype = isSubtypePrefix(
        subType,
        "renovacion_tarifa",
        "renovacion_completa"
      );
      const allowedFields = [];
      if (subtypeAllowsField("autoconsumo") || isCompleteSubtype) allowedFields.push("autoconsumo_id");
      if (subtypeAllowsField("potencia") || isCompleteSubtype || isTarifaRenewalSubtype) {
        allowedFields.push("potencias");
      }
      if (subtypeAllowsField("cnae") || isCompleteSubtype) allowedFields.push("cnae");
      if (subtypeAllowsField("consumo") || isCompleteSubtype) allowedFields.push("consumo_anual_previsto");
      if (subtypeAllowsField("distribuidora") || isCompleteSubtype) {
        allowedFields.push("cups_distribuidora_id", "cups_distribuidora_name");
      }

      // En renovación, los campos CUPS deben mantenerse; solo permitimos
      // edición cuando el valor esté vacío para poder completarlo.
      if (fieldName.startsWith("cups_")) {
        if (allowedFields.includes(fieldName)) {
          return false;
        }
        const currentValue = getValues(fieldName);
        return shouldLockCurrentValue(fieldName, currentValue);
      }

      if (technicalFields.includes(fieldName)) {
        if (allowedFields.includes(fieldName)) {
          return false;
        }
        const currentValue = getValues(fieldName);
        return shouldLockCurrentValue(fieldName, currentValue);
      }
      if (fieldName.startsWith("potencias.")) {
        if (allowedFields.includes("potencias")) {
          return false;
        }
        const currentValue = getValues(fieldName);
        return shouldLockCurrentValue(fieldName, currentValue);
      }
      // Bloquear dirección
      return true;
    }

    // Fallback general: si los datos vienen de ERP o SIPS, bloquear campos con valor
    // y permitir editar únicamente los campos vacíos.
    if (hasExternalDataLock) {
      const currentValue = getValues(fieldName);
      return shouldLockCurrentValue(fieldName, currentValue);
    }

    return false;
  };

  const getInitialPotencias = () => {
    return {}; // Retorna un objeto vacío por defecto
  };

  const defaultValues = {
    cups_id: "",
    cups_name: "",
    consumo_anual_previsto: "",
    autoconsumo_id: "",
    cups_distribuidora_id: "",
    cups_distribuidora_name: "",
    cnae: "",
    cnae_desc: "",
    cups_ref_catastral: "",
    cups_aclarador: "",
    cups_nv: "",
    cups_pt: "",
    cups_pu: "",
    cups_es: "",
    cups_pnp: "",
    cups_dp: "",
    cups_id_pais: 67,
    cups_id_provincia: "",
    cups_id_municipi: "",
    cups_id_poblacio: "",
    cups_tv: "",
    potencias: getInitialPotencias(),
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    getValues,
    setValue,
    reset,
    formState: { errors, isSubmitting, dirtyFields },
  } = useForm({
    mode: "onSubmit",
    defaultValues: defaultValues,
    resolver: yupResolver(cupsSchema(sector_type)),
  });

  const { setActionHandler, setIsSubmitting } = useOfferWizard();

  const applyGasDistribuidoraFromSource = useCallback((source, options = {}) => {
    if (sector_type !== "gas") return false;
    const { shouldDirty = false, sourceType = "manual" } = options;
    const resolved = resolveGasDistribuidoraFromSource(source);
    if (!resolved) return false;

    setValue("cups_distribuidora_id", resolved.id, { shouldValidate: true, shouldDirty });
    setValue("cups_distribuidora_name", resolved.name, { shouldValidate: true, shouldDirty });
    setGasDistribuidoraSource(sourceType);
    return true;
  }, [sector_type, resolveGasDistribuidoraFromSource, setValue]);

  const clearAddressFields = () => {
    [
      "cups_tv",
      "cups_nv",
      "cups_pt",
      "cups_pu",
      "cups_es",
      "cups_pnp",
      "cups_dp",
      "cups_aclarador",
      "cups_id_municipi",
      "cups_id_poblacio",
      "cups_id_provincia",
    ].forEach((key) => setValue(key, "", { shouldValidate: false }));
    setValue("cups_id_pais", 67, { shouldValidate: false });
    setAddressPrefillLabels({ provincia: "", municipio: "", poblacion: "", tipoVia: "" });
    setLockedAddressFields({});
  };

  // Sync submitting state
  useEffect(() => {
    setIsSubmitting(isSubmitting);
  }, [isSubmitting, setIsSubmitting]);



  useEffect(() => {
    const get_datos_iniciales = async () => {
      setLoader("Cargando datos iniciales");
      setValue("cups_id_pais", 67); // Establecer España como país
      await get_paises();
      await get_provincias(67); // Cargar provincias de España directamente
      await get_tipovia();
      await get_cnaes();
      if (params.sector_type === "gas") {
        await get_distribuidoras_gas();
      }
      removeLoader();
      if (!params.oferta_id || params.oferta_id === "null" || params.oferta_id === 'undefined') {
        return;
      }
      const oferta = await get_datos_oferta_erp(params.oferta_id);
      setOfertaErp(oferta);
    };

    if (location.state) {
      setEditMode(location.state.editMode);
    }
    get_datos_iniciales();
  }, []);

  // Efecto para inicializar potencias
  useEffect(() => {
    if (oferta_erp?.sector_type !== "electrico") {
      //Nomes carreguem potencies en llum, perque sino en gas, al no tenir-n'he cancela carga de camps al formulari
      return;
    }

    const potencias = {};
    const tarifa = Array.isArray(oferta_erp.tarifa_oferta)
      ? oferta_erp.tarifa_oferta[0]
      : oferta_erp.tarifa_oferta;
    const cantPotencias = tarifa === 41 ? 2 : 6;

    for (let index = 0; index < cantPotencias; index++) {
      const potKey = `P${index + 1}`;
      // Convertir a string con coma decimal si es necesario
      const potenciaValue = oferta_erp.potencias?.[potKey];
      potencias[potKey] = typeof potenciaValue === 'number' ?
        potenciaValue.toString().replace(".", ",") :
        "";
    }

    setValue("potencias", potencias);
  }, [oferta_erp, setValue]);

  const fetchMunicipios = async (provId, restoreMunicipio = null) => {
    if (provId) {
      setLoadingMuni(true);
      setValue("cups_id_municipi", null, { shouldValidate: false });
      setValue("cups_id_poblacio", null, { shouldValidate: false });
      await get_municipios(provId);
      if (restoreMunicipio !== null && restoreMunicipio !== undefined) {
        setValue("cups_id_municipi", restoreMunicipio, {
          shouldValidate: false,
        });
      }
      setLoadingMuni(false);
    }
  };

  const fetchPoblaciones = async (muniId, restorePoblacion = null) => {
    if (muniId) {
      setLoadingPob(true);
      setValue("cups_id_poblacio", null, { shouldValidate: false });
      await get_poblaciones(muniId);
      if (restorePoblacion !== null && restorePoblacion !== undefined) {
        setValue("cups_id_poblacio", restorePoblacion, {
          shouldValidate: false,
        });
      }
      setLoadingPob(false);
    }
  };

  const fetchProvincias = async (paisId) => {
    if (!paisId) return;
    setLoadingProv(true);
    setValue("cups_id_provincia", null, { shouldValidate: false });
    setValue("cups_id_municipi", null, { shouldValidate: false });
    setValue("cups_id_poblacio", null, { shouldValidate: false });
    await get_provincias(paisId);
    setLoadingProv(false);
  };

  const [failedDistribuidoraLookup, setFailedDistribuidoraLookup] = useState(null);

  const fetchDistribuidora = async (cupsName) => {
    if (!cupsName || cupsName.length < 6 || failedDistribuidoraLookup === cupsName) {
      return;
    }
    setValue("cups_distribuidora_id", "");
    setValue("cups_distribuidora_name", "");

    const distribuidora = await getDistribuidoras(cupsName);
    if (distribuidora) {
      setValue("cups_distribuidora_id", distribuidora.id, {
        shouldValidate: true,
      });
      setValue("cups_distribuidora_name", distribuidora.name, {
        shouldValidate: true,
      });
      setFailedDistribuidoraLookup(null);
    } else {
      setFailedDistribuidoraLookup(cupsName);
    }
  };

  const clearCupsSearchDerivedFields = () => {
    setValue("consumo_anual_previsto", "", { shouldValidate: false, shouldDirty: true });
    setValue("autoconsumo_id", "", { shouldValidate: false, shouldDirty: true });
    setRefCatastralReadOnly(false);
    setValue("cups_distribuidora_id", "", { shouldValidate: false, shouldDirty: true });
    setValue("cups_distribuidora_name", "", { shouldValidate: false, shouldDirty: true });
    setValue("cnae", "", { shouldValidate: false, shouldDirty: true });
    setValue("cnae_desc", "", { shouldValidate: false, shouldDirty: true });
    setValue("cups_ref_catastral", "", { shouldValidate: false, shouldDirty: true });
    setValue("potencias", getInitialPotencias(), { shouldValidate: false, shouldDirty: true });
    clearAddressFields();
    setAddressLoadError(null);
    setAddressPrefillLabels({ provincia: "", municipio: "", poblacion: "", tipoVia: "" });
    setSipsGasTechnicalData(null);
    setSipsTechnicalData(null);
    setSipsBusinessWarnings([]);
    setSipsTarifaAcceso(null);
    setSipsWarning(null);
    setActiveContractWarning(null);
    setCups(false);
    setIsCupsInErp(false);
    setGasDistribuidoraSource("none");
    erpCupsAddressRef.current = null;
    pendingGasDistribuidoraRef.current = null;
    setFailedDistribuidoraLookup(null);
  };

  const loadAddressIntoForm = async (address, options = {}) => {
    const { preserveExistingOnEmpty = false } = options;
    const normalizeId = (value) => {
      const raw = Array.isArray(value)
        ? value[0]
        : value && typeof value === "object" && value.id !== undefined
          ? value.id
          : value;
      if (raw === null || raw === undefined || raw === "" || raw === false) return "";
      const num = Number(raw);
      return Number.isNaN(num) ? "" : num;
    };
    const isEmptyValue = (value) => {
      if (value === null || value === undefined) return true;
      if (typeof value === "string") return value.trim() === "";
      if (Array.isArray(value)) return value.length === 0;
      return false;
    };
    const currentValues = preserveExistingOnEmpty ? getValues() : null;
    const keepOrIncoming = (key, incomingValue) => {
      if (!preserveExistingOnEmpty) return incomingValue;
      if (!isEmptyValue(incomingValue)) return incomingValue;
      return currentValues?.[key] ?? "";
    };
    const tick = () => new Promise((r) => setTimeout(r, 0));

    const sanitized = { ...address };
    const countryId = 67;
    const provinciaId = keepOrIncoming("cups_id_provincia", normalizeId(sanitized.cups_id_provincia));
    const municipioId = keepOrIncoming("cups_id_municipi", normalizeId(sanitized.cups_id_municipi));
    const poblacionId = keepOrIncoming("cups_id_poblacio", normalizeId(sanitized.cups_id_poblacio));
    const tipoViaId = keepOrIncoming("cups_tv", normalizeId(sanitized.cups_tv));

    await get_tipovia();
    await get_provincias(countryId);
    await tick();
    setValue("cups_id_pais", String(countryId), { shouldValidate: false });
    setValue("cups_id_provincia", provinciaId ? String(provinciaId) : "", { shouldValidate: false });

    if (provinciaId) {
      await get_municipios(provinciaId);
      await tick();
      setValue("cups_id_municipi", municipioId ? String(municipioId) : "", { shouldValidate: false });
    } else {
      setValue("cups_id_municipi", "", { shouldValidate: false });
    }

    if (municipioId) {
      await get_poblaciones(municipioId);
      await tick();
      setValue("cups_id_poblacio", poblacionId ? String(poblacionId) : "", { shouldValidate: false });
    } else {
      setValue("cups_id_poblacio", "", { shouldValidate: false });
    }

    await tick();
    const finalTv = tipoViaId ? String(tipoViaId) : "";
    setValue("cups_tv", finalTv, { shouldValidate: false });
    const finalTextValues = {};
    ["cups_nv", "cups_pt", "cups_pu", "cups_es", "cups_pnp", "cups_dp", "cups_aclarador"].forEach((key) => {
      const finalValue = keepOrIncoming(key, sanitized[key] ?? "");
      finalTextValues[key] = finalValue;
      setValue(key, finalValue, { shouldValidate: false });
    });

    // Bloqueo determinista: un campo queda de solo lectura si, tras esta carga,
    // tiene un valor no vacío. No depende de "dirty" ni de subtipos.
    const finalValuesByField = {
      cups_id_pais: String(countryId),
      cups_id_provincia: provinciaId ? String(provinciaId) : "",
      cups_id_municipi: municipioId ? String(municipioId) : "",
      cups_id_poblacio: poblacionId ? String(poblacionId) : "",
      cups_tv: finalTv,
      ...finalTextValues,
    };
    setLockedAddressFields(
      Object.fromEntries(
        Object.entries(finalValuesByField).map(([key, value]) => [key, !isEmptyValue(value)])
      )
    );
  };

  // Extrae los nombres legibles de los campos ERP en formato array (ej. state_id: [52, "Salamanca"])
  const extractAddressPrefillLabels = (source) => {
    if (!source) return {};
    const stateMeta = getIdAndName(source.state_id ?? source.cups_id_provincia ?? source.provincia_id);
    const municipioMeta = getIdAndName(source.id_municipi ?? source.cups_id_municipi ?? source.municipi_id);
    const poblacionMeta = getIdAndName(source.id_poblacio ?? source.cups_id_poblacio ?? source.poblacio_id);
    const tipoViaMeta = getIdAndName(source.tv ?? source.cups_tv);
    return {
      provincia: stateMeta.name || "",
      municipio: municipioMeta.name || "",
      poblacion: poblacionMeta.name || "",
      tipoVia: tipoViaMeta.name || "",
    };
  };

  // Build cups_* address object from raw ERP CUPS record (unprefixed field names)
  const buildAddressFromCupsErpData = (cupsData) => {
    if (!cupsData || typeof cupsData !== 'object') return null;
    return {
      cups_tv: toNumericId(cupsData.tv ?? cupsData.cups_tv),
      cups_nv: cupsData.nv || "",
      cups_pt: cupsData.pt || "",
      cups_pu: cupsData.pu || "",
      cups_es: cupsData.es || "",
      cups_pnp: cupsData.pnp || "",
      cups_dp: cupsData.dp || cupsData.zip || cupsData.cups_dp || "",
      cups_aclarador: cupsData.aclarador || "",
      cups_id_pais: 67,
      cups_id_provincia: toNumericId(
        cupsData.state_id ?? cupsData.id_provincia ?? cupsData.cups_id_provincia ?? cupsData.provincia_id
      ),
      cups_id_municipi: toNumericId(
        cupsData.id_municipi ?? cupsData.cups_id_municipi ?? cupsData.municipi_id
      ),
      cups_id_poblacio: toNumericId(
        cupsData.id_poblacio ?? cupsData.cups_id_poblacio ?? cupsData.poblacio_id
      ),
    };
  };

  const buildAddressFromOffer = (offer) => {
    if (!offer) return null;
    return {
      cups_tv: toNumericId(offer.cups_tv),
      cups_nv: offer.cups_nv || "",
      cups_pt: offer.cups_pt || "",
      cups_pu: offer.cups_pu || "",
      cups_es: offer.cups_es || "",
      cups_pnp: offer.cups_pnp || "",
      cups_dp: offer.cups_dp || "",
      cups_aclarador: offer.cups_aclarador || "",
      cups_id_pais: toNumericId(offer.cups_id_pais) || 67,
      cups_id_provincia: toNumericId(offer.cups_id_provincia),
      cups_id_municipi: toNumericId(offer.cups_id_municipi),
      cups_id_poblacio: toNumericId(offer.cups_id_poblacio),
    };
  };

  // Initialize form with CUPS data (NO address fields - those come from partner)
  useEffect(() => {
    const initForm = async () => {
      if (oferta_erp) {
        try {
          const elec = oferta_erp.sector_type === "electrico";
          // Inicialitza potencies nomes per electricitat, per gas NO
          if (elec) {
            const potencias = {};
            const tarifa = Array.isArray(oferta_erp.tarifa_oferta)
              ? oferta_erp.tarifa_oferta[0]
              : oferta_erp.tarifa_oferta;
            const cantPotencias = tarifa === 41 ? 2 : 6;

            for (let index = 0; index < cantPotencias; index++) {
              const potKey = `P${index + 1}`;
              potencias[potKey] = oferta_erp.potencias?.[potKey]?.toString().replace(".", ",") || "";
            }
          }

          applyAutoconsumoValue(oferta_erp.autoconsumo);

          // Campos comunes (NO de dirección)
          const offerRefCatastral = resolveCupsRefCatastral(oferta_erp);
          if (offerRefCatastral) {
            markRefCatastralAsPreloaded(offerRefCatastral);
            setValue("cups_ref_catastral", offerRefCatastral);
          }
          if (oferta_erp.cups_id) setValue("cups_id", oferta_erp.cups_id);

          // Cargar dirección guardada del CUPS si existe.
          const savedOfferAddress = buildAddressFromOffer(oferta_erp);
          if (hasAddressData(savedOfferAddress)) {
            const offerLabels = extractAddressPrefillLabels(oferta_erp);
            if (offerLabels.provincia || offerLabels.municipio) {
              setAddressPrefillLabels(offerLabels);
            }
            await loadAddressIntoForm(savedOfferAddress);
          } else if (erpCupsAddressRef.current && hasAddressData(erpCupsAddressRef.current)) {
            // CUPS found in ERP: load address from ERP CUPS record
            await loadAddressIntoForm(erpCupsAddressRef.current);
          } else {
            clearAddressFields();
            // Allow partner address to reload after CUPS search
            setPartnerAddressLoaded(false);
          }

          // En cambio de titular, la dirección debe provenir solo del CUPS/oferta.
          if (
            isCambioTitularSubtype(oferta_erp.sub_type_offer)
            && !isCambioComercializadoraSubtype(oferta_erp.sub_type_offer)
          ) {
            setUseClientAddress(false);
            setClientAddress(null);
            setAddressLoadError(null);
          }

          if (elec ? oferta_erp.cups_name : oferta_erp.cups_global) {
            setValue(
              "cups_name",
              elec ? oferta_erp.cups_name : oferta_erp.cups_global
            );
          }
          if (elec ? oferta_erp.cnae : oferta_erp.cnae_gas) {
            const cnae = elec ? oferta_erp.cnae : oferta_erp.cnae_gas;
            setValue("cnae", cnae);
            changeCnae(cnae);
          }
          if (
            elec
              ? oferta_erp.consumo_anual_previsto_directo
              : oferta_erp.consumo_anual_gas_previsto_directo
          ) {
            setValue(
              "consumo_anual_previsto",
              elec
                ? oferta_erp.consumo_anual_previsto_directo
                : oferta_erp.consumo_anual_gas_previsto_directo
            );
          }
          //Seteo la distribuidora en electricidad
          if (elec && oferta_erp.cups_distribuidora_id) {
            setValue("cups_distribuidora_id", oferta_erp.cups_distribuidora_id[0], { shouldValidate: true });
            setValue("cups_distribuidora_name", oferta_erp.cups_distribuidora_id[1], { shouldValidate: true });
          } else if (pendingGasDistribuidoraRef.current) {
            const dist = pendingGasDistribuidoraRef.current;
            pendingGasDistribuidoraRef.current = null;
            applyGasDistribuidoraFromSource(dist, { sourceType: "sips" });
          } else if (oferta_erp.cups_gas_distribuidora_id) {
            applyGasDistribuidoraFromSource(
              { cups_gas_distribuidora_id: oferta_erp.cups_gas_distribuidora_id },
              { sourceType: "manual" }
            );
          } else if (!elec) {
            applyGasDistribuidoraFromSource(oferta_erp, { sourceType: "manual" });
          } else if (elec) {
            const cupsNameForDistribuidora = oferta_erp.cups_name || oferta_erp.cups_global || "";
            if (cupsNameForDistribuidora && cupsNameForDistribuidora.length >= 6 &&
              distribuidoraRequestRef.current !== cupsNameForDistribuidora) {
              distribuidoraRequestRef.current = cupsNameForDistribuidora;
              fetchDistribuidora(cupsNameForDistribuidora);
            }
          }
          setType(oferta_erp.type);
        } catch (error) {
          console.error("Error loading CUPS data:", error);
        }
      }
    };

    initForm();
  }, [oferta_erp, applyGasDistribuidoraFromSource]);


  const onSearchCups = async () => {
  //Si falla get_cups(...) el formulario se rellena con get_datos_oferta_erp(...) cargando la direccion que ya tenia en la oferta.
/*
 * Proceso de búsqueda de CUPS:
 * 1. Se normaliza el CUPS introducido y se limpia cualquier información derivada
 *    de búsquedas anteriores para evitar reutilizar datos obsoletos.
 *
 * 2. Se consulta SIPS (btn_search_sips) para obtener información regulada del
 *    punto de suministro, como CNAE, consumo, datos técnicos, distribuidora
 *    o referencia catastral. En el caso eléctrico, previamente también se
 *    realiza una importación SIPS (btn_import_sips), que puede devolver
 *    información adicional del suministro y persistirla en el ERP.
 *
 * 3. Se consulta el ERP (get_cups) para comprobar si el CUPS ya existe dentro
 *    del sistema y recuperar datos internos como la dirección, distribuidora,
 *    información contractual u otros datos ya sincronizados.
 *
 * 4. Orden de prioridad y mecanismos de fallback:
 *    - Si existen datos en ERP (get_cups), estos tienen prioridad para
 *      rellenar la dirección y la información asociada al CUPS.
 *    - Si ERP no dispone de la información o no encuentra el CUPS, se intenta
 *      utilizar la información obtenida desde SIPS mediante
 *      btn_import_sips y btn_search_sips.
 *    - Como último recurso, se refresca la oferta desde ERP mediante
 *      get_datos_oferta_erp para recuperar datos que hayan podido ser
 *      sincronizados de forma asíncrona después de la consulta a SIPS.
 *
 * 5. Comportamiento en caso de error o ausencia de resultados:
 *    - Si falla o no devuelve resultados btn_search_sips, la búsqueda continúa con los datos disponibles en get_cups y posteriormente con
 *      get_datos_oferta_erp.
 *    - Si falla o no encuentra información get_cups, se utilizan los datos devueltos por btn_import_sips y/o btn_search_sips como fuente de
 *      respaldo.
 *    - Si btn_import_sips devuelve información parcial o no devuelve dirección, se intenta cargar la dirección desde get_cups y, en última
 *      instancia, desde get_datos_oferta_erp.
 *    - Si ninguna de las fuentes (btn_search_sips, btn_import_sips, get_cups o get_datos_oferta_erp) devuelve la información requerida,
 *      los campos permanecen vacíos para que el usuario los complete manualmente.
 */
    if (isSearchingCups) return;
    setIsSearchingCups(true);
    setIsSipsNotFoundAfterSearch(false);
    const data = getValues();
    const normalizedCupsName = normalizeCupsForSearch(data.cups_name);

    if (!normalizedCupsName) {
      setIsSearchingCups(false);
      return;
    }

    if (normalizedCupsName !== data.cups_name) {
      setValue("cups_name", normalizedCupsName, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }

    // Start every search from a clean state to avoid leaking previous CUPS data.
    clearCupsSearchDerivedFields();
    await clear_oferta_cups_erp(oferta_erp.id, sector_type);

    const searchData = {
      ...data,
      cups_name: normalizedCupsName,
    };

    
    const autoconsumoOferta = data.autoconsumo_id || oferta_erp?.autoconsumo || "";
    let cupsFound = false;
    let cupsData = null;
    let erpCupsData = null;
    let erpGasCupsData = null;
    let sipsGlobalData = null;
    const cnaeBeforeSearch = searchData.cnae;

    const normalizeCnaeValue = (value) => {
      if (!value) return "";
      if (Array.isArray(value)) {
        if (value.length > 1 && value[1]) return String(value[1]);
        if (value.length > 0 && value[0] !== undefined && value[0] !== null) return String(value[0]);
        return "";
      }
      if (typeof value === "object") {
        return String(value.name || value.code || value.id || "");
      }
      return String(value);
    };

    try {
      if (sector_type === 'gas') {
        setLoader("Buscando CUPS en SIPS");
        setGasDistribuidoraSource("none");
        setIsCupsInErp(false);
        sipsGlobalData = await btn_search_sips(searchData.cups_name, 'gas', isAltaNuevo);
        if (sipsGlobalData) {
          setSipsTechnicalData(null);
          setSipsBusinessWarnings([]);
          // Extract gas-specific technical data from SIPS
          const gasTechData = buildSipsGasTechnicalData(sipsGlobalData);
          const hasGasTech = gasTechData.caudal_horario || gasTechData.caudal_maximo_diario || gasTechData.codigo_presion;
          setSipsGasTechnicalData(hasGasTech ? gasTechData : null);
          if (!getValues("consumo_anual_previsto") && sipsGlobalData.consumoAnual) {
            setValue("consumo_anual_previsto", sipsGlobalData.consumoAnual);
          }
          if (sipsGlobalData.nombreEmpresaDistribuidora && distribuidorasGas?.length) {
            const matched = matchDistribuidoraFromSips(sipsGlobalData.nombreEmpresaDistribuidora, distribuidorasGas);
            if (matched) {
              pendingGasDistribuidoraRef.current = matched;
              applyGasDistribuidoraFromSource(matched, { shouldDirty: true, sourceType: "sips" });
            }
          }
        }
        // Check ERP for existing gas CUPS to load address data
        try {
          erpGasCupsData = await get_cups(searchData.cups_name, oferta_erp.user_id?.[0], oferta_erp.id, 'gas', true);
          if (erpGasCupsData) {
            const hasActiveContract = erpGasCupsData.polissa_activa?.data_baixa === false
            if((isAltaNuevo || isCambioComercializadora) && hasActiveContract) {
              setActiveContractWarning("Suministro ya activo en esta compañía");
              return;
            }
            else setActiveContractWarning(null);
        
            setIsCupsInErp(true);
            setUseClientAddress(false);
            const erpAddress = buildAddressFromCupsErpData(erpGasCupsData);
            erpCupsAddressRef.current = erpAddress;
            const gasLabels = extractAddressPrefillLabels(erpGasCupsData);
            if (gasLabels.provincia || gasLabels.municipio) {
              setAddressPrefillLabels(gasLabels);
            }
            if (hasAddressData(erpAddress)) {
              await loadAddressIntoForm(erpAddress, { preserveExistingOnEmpty: true });
            }
            applyGasDistribuidoraFromSource(erpGasCupsData, { shouldDirty: true, sourceType: "erp" });
          }
        } catch (e) { /* non-blocking: address can be entered manually */ }
        if (sipsGlobalData?.cnae) {
          setValue("cnae", sipsGlobalData.cnae);
          changeCnae(sipsGlobalData.cnae);
        }
        const currentSearchRefCatastral = getValues("cups_ref_catastral");
        const gasRefCatastralValue =
          resolveCupsRefCatastral(erpGasCupsData) ||
          resolveCupsRefCatastral(sipsGlobalData);
        if (!currentSearchRefCatastral && gasRefCatastralValue) {
          markRefCatastralAsPreloaded(gasRefCatastralValue);
          setValue("cups_ref_catastral", gasRefCatastralValue, { shouldValidate: true });
        }
        setSipsCnaeValid(!!(sipsGlobalData?.cnae));
      } else {
        const importSipsResponse = await btn_import_sips(searchData.cups_name, oferta_erp.id, isAltaNuevo);
        cupsData = importSipsResponse && typeof importSipsResponse === "object" ? importSipsResponse : null;
        sipsGlobalData = await btn_search_sips(searchData.cups_name, 'electrico', isAltaNuevo);
        hydrateSipsTechnicalState(sipsGlobalData, cupsData);
        setSipsCnaeValid(!!(sipsGlobalData?.cnae));

        // Electric: after SIPS search, check ERP to load address data even when SIPS does not find the CUPS.
        try {
          erpCupsData = await get_cups(searchData.cups_name, oferta_erp.user_id?.[0], oferta_erp.id, sector_type, true);
          if (erpCupsData) {
            const hasActiveContract = erpCupsData.polissa_activa?.data_baixa === false //polissa_activa
            if((isAltaNuevo || isCambioComercializadora) && hasActiveContract) {
              setActiveContractWarning("Suministro ya activo en esta compañía");
              return;
            }
            else setActiveContractWarning(null);
            cupsFound = true;
            setIsCupsInErp(true);
            setUseClientAddress(false);
            const erpAddress = buildAddressFromCupsErpData(erpCupsData);
            erpCupsAddressRef.current = erpAddress;
            const elecLabels = extractAddressPrefillLabels(erpCupsData);
            if (elecLabels.provincia || elecLabels.municipio) {
              setAddressPrefillLabels(elecLabels);
            }
            if (hasAddressData(erpAddress)) {
              await loadAddressIntoForm(erpAddress, { preserveExistingOnEmpty: true });
            }

            const erpDistribuidora = getIdAndName(erpCupsData.cups_distribuidora_id);
            if (erpDistribuidora.id !== null && erpDistribuidora.id !== undefined && erpDistribuidora.id !== "") {
              setValue("cups_distribuidora_id", erpDistribuidora.id, { shouldValidate: true, shouldDirty: true });
              setValue(
                "cups_distribuidora_name",
                erpDistribuidora.name || `Distribuidora (${erpDistribuidora.id})`,
                { shouldValidate: true, shouldDirty: true }
              );
            } else {
              await fetchDistribuidora(searchData.cups_name);
            }
          } else {
            setIsCupsInErp(false);
            erpCupsAddressRef.current = null;
          }
        } catch (e) { setIsCupsInErp(false); erpCupsAddressRef.current = null; }

        const importedAddress = buildAddressFromCupsErpData(cupsData);
        if (hasAddressData(importedAddress)) {
          await loadAddressIntoForm(importedAddress, { preserveExistingOnEmpty: true });
        }

        const cnaeFromSearch =
          normalizeCnaeValue(cupsData?.cnae) ||
          normalizeCnaeValue(sipsGlobalData?.cnae) ||
          normalizeCnaeValue(erpCupsData?.cnae);

        if (cnaeFromSearch) {
          setValue("cnae", cnaeFromSearch, { shouldValidate: true });
          changeCnae(cnaeFromSearch);
        } else if (cnaeBeforeSearch) {
          // Never blank CNAE when search endpoints return partial payloads.
          setValue("cnae", cnaeBeforeSearch, { shouldValidate: true });
          changeCnae(cnaeBeforeSearch);
        }

        const currentSearchRefCatastral = getValues("cups_ref_catastral");
        //El paquet cupsData es qui porta el valor ref_catastral, altres estan de fallback
        const CupsRefCatastralValue =
          resolveCupsRefCatastral(cupsData) ||
          resolveCupsRefCatastral(erpCupsData) ||
          resolveCupsRefCatastral(sipsGlobalData);
        if (!currentSearchRefCatastral && CupsRefCatastralValue) {
          //Formulario camp es diu cups_ref_catastral tot i que payload CUPS pot portar camp ref_catastral.
          markRefCatastralAsPreloaded(CupsRefCatastralValue);
          setValue("cups_ref_catastral", CupsRefCatastralValue, { shouldValidate: true });
        }

        if (cupsData) {
          applyAutoconsumoValue(resolveAutoconsumoFromSource(cupsData), {
            preserveCurrentOnEmpty: true,
            fallbackValue: autoconsumoOferta,
          });

          if (isCambioComercializadora && (cupsData.polissa_activa || cupsData.tiene_contrato_ab)) {
            setActiveContractWarning("Este CUPS ya tiene un contrato activo en AB Energía.");
          } else {
            setActiveContractWarning(null);
          }

          if (!getValues("consumo_anual_previsto") && (sipsGlobalData?.consumoAnual || cupsData.consumoAnual)) {
            setValue("consumo_anual_previsto", sipsGlobalData?.consumoAnual || cupsData.consumoAnual);
          }
        }
      }

      if (cupsData) {
        // Do not refresh oferta here: ERP/SIPS async sync can return partial
        // data and overwrite complete form values already loaded.
        setCups(cupsData);
        setIsSipsNotFoundAfterSearch(false);
      } else if (erpCupsData) {
        applyAutoconsumoValue(resolveAutoconsumoFromSource(erpCupsData), {
          preserveCurrentOnEmpty: true,
          fallbackValue: autoconsumoOferta,
        });
        setCups(erpCupsData);
        setIsSipsNotFoundAfterSearch(false);
      } else {
        if (sipsGlobalData) {
          applyAutoconsumoValue(resolveAutoconsumoFromSource(sipsGlobalData), {
            preserveCurrentOnEmpty: true,
            fallbackValue: autoconsumoOferta,
          });
          setCups(sipsGlobalData);
          setIsSipsNotFoundAfterSearch(false);
        } else {
          setCups(false);
          setIsSipsNotFoundAfterSearch(true);
          if (isAltaNuevo) {
            toast.warning(
              "Al tratarse de un Alta de suministro, el valor de CUPS no puede localizarse en SIPS y deberá alimentar sus datos de forma manual.",
              { position: toast.POSITION.TOP_CENTER }
            );
          }
        }

        if (sector_type !== 'gas' && !getValues("cups_distribuidora_id")) {
          await fetchDistribuidora(searchData.cups_name);
        }
      }

      // Best-effort hydration from refreshed offer after SIPS import.
      // Some ERP sync paths persist data asynchronously and may not be
      // reflected in current local payloads until a later read.
      try {
        const refreshedOffer = await get_datos_oferta_erp(oferta_erp.id);
        if (refreshedOffer) {
          const elecRefreshed = refreshedOffer.sector_type === "electrico";
          const refreshedAddress = buildAddressFromOffer(refreshedOffer);

          if (hasAddressData(refreshedAddress)) {
            const refreshedLabels = extractAddressPrefillLabels(refreshedOffer);
            if (refreshedLabels.provincia || refreshedLabels.municipio) {
              setAddressPrefillLabels(refreshedLabels);
            }
            await loadAddressIntoForm(refreshedAddress, { preserveExistingOnEmpty: true });
          }

          const currentCnae = normalizeCnaeValue(getValues("cnae"));
          const refreshedCnae = normalizeCnaeValue(
            elecRefreshed ? refreshedOffer.cnae : refreshedOffer.cnae_gas
          );
          if (!currentCnae && refreshedCnae) {
            setValue("cnae", refreshedCnae, { shouldValidate: true });
            changeCnae(refreshedCnae);
          }

          const currentConsumption = getValues("consumo_anual_previsto");
          const refreshedConsumption = elecRefreshed
            ? refreshedOffer.consumo_anual_previsto_directo
            : refreshedOffer.consumo_anual_gas_previsto_directo;
          if (!currentConsumption && refreshedConsumption) {
            setValue("consumo_anual_previsto", refreshedConsumption, { shouldValidate: true });
          }

          if (elecRefreshed && refreshedOffer.potencias) {
            const currentPotencias = getValues("potencias") || {};
            const refreshedPotencias = refreshedOffer.potencias || {};
            const tarifaId = refreshedOffer?.tarifa_oferta?.[0];
            const periodsCount = tarifaId === 41 ? 2 : 6;
            let hasAnyPotenciaUpdate = false;
            const nextPotencias = { ...currentPotencias };

            for (let index = 0; index < periodsCount; index++) {
              const potKey = `P${index + 1}`;
              const currentValue = nextPotencias?.[potKey];
              const refreshedValue = refreshedPotencias?.[potKey];
              const isCurrentEmpty = currentValue === null || currentValue === undefined || String(currentValue).trim() === "";
              if (!isCurrentEmpty || refreshedValue === null || refreshedValue === undefined || refreshedValue === "") {
                continue;
              }

              nextPotencias[potKey] = typeof refreshedValue === "number"
                ? refreshedValue.toString().replace(".", ",")
                : String(refreshedValue).replace(".", ",");
              hasAnyPotenciaUpdate = true;
            }

            if (hasAnyPotenciaUpdate) {
              setValue("potencias", nextPotencias, { shouldValidate: false });
            }
          }

          const currentRefCatastral = getValues("cups_ref_catastral");
          const refreshedRefCatastral = resolveCupsRefCatastral(refreshedOffer);
          if (!currentRefCatastral && refreshedRefCatastral) {
            markRefCatastralAsPreloaded(refreshedRefCatastral);
            setValue("cups_ref_catastral", refreshedRefCatastral, { shouldValidate: true });
          }

          const currentDistId = getValues("cups_distribuidora_id");
          if (!currentDistId) {
            if (elecRefreshed && refreshedOffer.cups_distribuidora_id?.[0]) {
              setValue("cups_distribuidora_id", refreshedOffer.cups_distribuidora_id[0], { shouldValidate: true });
              setValue("cups_distribuidora_name", refreshedOffer.cups_distribuidora_id?.[1] || "", { shouldValidate: true });
            } else if (!elecRefreshed) {
              applyGasDistribuidoraFromSource(refreshedOffer, { sourceType: "manual" });
            }
          }
        }
      } catch (syncError) {
        console.warn("No se pudo hidratar la oferta tras buscar CUPS", syncError);
      }
    } finally {
      if (sector_type === 'gas') removeLoader();
      setIsSearchingCups(false);
    }
  };

  // Load SIPS technical fields when opening an existing offer with CUPS.
  useEffect(() => {
    const prefetchSipsTechnicalData = async () => {
      if (!oferta_erp || initialSipsLoadRef.current) {
        return;
      }

      const cupsName = oferta_erp?.cups_name || oferta_erp?.cups_global;
      if (!cupsName || String(cupsName).length < 20 || isRenewalSubtype) {
        return;
      }

      initialSipsLoadRef.current = true;
      try {
        const sipsGlobalData = await btn_search_sips(cupsName, sector_type, isAltaNuevo);
        if (sipsGlobalData) {
          if (sector_type === "electrico") {
            hydrateSipsTechnicalState(sipsGlobalData, null);
          } else {
            // Gas: extract gas-specific technical data
            const gasTechData = buildSipsGasTechnicalData(sipsGlobalData);
            const hasGasTech = gasTechData.caudal_horario || gasTechData.caudal_maximo_diario || gasTechData.codigo_presion;
            setSipsGasTechnicalData(hasGasTech ? gasTechData : null);
          }
          // Populate annual consumption if not already set
          if (!getValues("consumo_anual_previsto") && sipsGlobalData.consumoAnual) {
            setValue("consumo_anual_previsto", sipsGlobalData.consumoAnual);
          }
        }
      } catch (error) {
        // Non-blocking: manual search still available.
        console.warn("No se pudieron precargar los datos técnicos SIPS", error);
      }
    };

    prefetchSipsTechnicalData();
  }, [oferta_erp, sector_type, isRenewalSubtype, hydrateSipsTechnicalState]);

  // On initial load, check if the CUPS already exists in the ERP.
  // If it does, load the ERP address and lock fields; otherwise leave editable.
  useEffect(() => {
    const checkErpCupsOnLoad = async () => {
      if (!oferta_erp || initialErpCupsCheckRef.current) {
        return;
      }

      const cupsNameToCheck = oferta_erp.cups_name || oferta_erp.cups_global;
      if (!cupsNameToCheck || String(cupsNameToCheck).length < 20) {
        return;
      }

      initialErpCupsCheckRef.current = true;
      try {
        const cupsData = await get_cups(cupsNameToCheck, oferta_erp.user_id?.[0], oferta_erp.id, sector_type, true);
        if (cupsData) {
          const erpAddress = buildAddressFromCupsErpData(cupsData);
          erpCupsAddressRef.current = erpAddress;
          setIsCupsInErp(true);
          const erpLabels = extractAddressPrefillLabels(cupsData);
          if (erpLabels.provincia || erpLabels.municipio) {
            setAddressPrefillLabels(erpLabels);
          }
          if (erpAddress) {
            await loadAddressIntoForm(erpAddress);
          }
          if (sector_type === "gas") {
            applyGasDistribuidoraFromSource(cupsData, { sourceType: "manual" });
          } else {
            const erpDistribuidora = getIdAndName(cupsData.cups_distribuidora_id);
            if (erpDistribuidora.id !== null && erpDistribuidora.id !== undefined && erpDistribuidora.id !== "") {
              setValue("cups_distribuidora_id", erpDistribuidora.id, { shouldValidate: true });
              setValue(
                "cups_distribuidora_name",
                erpDistribuidora.name || `Distribuidora (${erpDistribuidora.id})`,
                { shouldValidate: true }
              );
            } else {
              await fetchDistribuidora(cupsNameToCheck);
            }
          }
        } else {
          setIsCupsInErp(false);
          erpCupsAddressRef.current = null;
        }
      } catch (e) {
        setIsCupsInErp(false);
        erpCupsAddressRef.current = null;
      }
    };

    checkErpCupsOnLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oferta_erp, sector_type, applyGasDistribuidoraFromSource]);

  // Load Partner Address - Using same pattern as OfertaPagador
  useEffect(() => {
    if (isCambioTitular) {
      setUseClientAddress(false);
      setClientAddress(null);
      setAddressLoadError(null);
      setPartnerAddressLoaded(true);
      return;
    }

    if (!oferta_erp || partnerAddressLoaded) return;
    const loadPartnerAddress = async () => {
      try {
        setLoadingAddress(true);
        setAddressLoadError(null);
        const partnerId = oferta_erp.partner_id?.[0];
        let partnerData = null;
        if (partnerId) {
          partnerData = await get_partner_by_id(partnerId);
        } else if (oferta_erp.cliente_vat) {
          partnerData = await get_partner_by_vat(oferta_erp.cliente_vat);
        }

        if (!partnerData) {
          console.warn("Partner not found, user must enter address manually");
          return;
        }

        const partnerAddress = {
          cups_tv: toNumericId(partnerData.tv ?? partnerData.cups_tv ?? partnerData.tipo_via_id),
          cups_nv: partnerData.nv || partnerData.cups_nv || "",
          cups_pt: partnerData.pt || partnerData.cups_pt || "",
          cups_pu: partnerData.pu || partnerData.cups_pu || "",
          cups_es: partnerData.es || partnerData.cups_es || "",
          cups_pnp: partnerData.pnp || partnerData.cups_pnp || "",
          cups_dp: partnerData.zip || partnerData.dp || partnerData.cups_dp || "",
          cups_aclarador: partnerData.aclarador || partnerData.cups_aclarador || "",
          cups_id_pais: toNumericId(partnerData.country_id ?? partnerData.cups_id_pais) || 67,
          cups_id_provincia: toNumericId(partnerData.state_id ?? partnerData.cups_id_provincia ?? partnerData.provincia_id),
          cups_id_municipi: toNumericId(partnerData.id_municipi ?? partnerData.cups_id_municipi ?? partnerData.municipi_id),
          cups_id_poblacio: toNumericId(partnerData.id_poblacio ?? partnerData.cups_id_poblacio ?? partnerData.poblacio_id),
        };

        const stateMeta = getIdAndName(partnerData.state_id ?? partnerData.cups_id_provincia ?? partnerData.provincia_id);
        const municipioMeta = getIdAndName(partnerData.id_municipi ?? partnerData.cups_id_municipi ?? partnerData.municipi_id);
        const poblacionMeta = getIdAndName(partnerData.id_poblacio ?? partnerData.cups_id_poblacio ?? partnerData.poblacio_id);
        const tipoViaMeta = getIdAndName(partnerData.tv ?? partnerData.cups_tv ?? partnerData.tipo_via_id);
        setAddressPrefillLabels({
          provincia: stateMeta.name || "",
          municipio: municipioMeta.name || "",
          poblacion: poblacionMeta.name || "",
          tipoVia: tipoViaMeta.name || "",
        });

        setClientAddress(partnerAddress);

        const savedOfferAddress = buildAddressFromOffer(oferta_erp);
        if (!isCupsInErp && !useClientAddress && shouldAutoUseClientAddress(savedOfferAddress, partnerAddress)) {
          // Auto-restore checkbox state when stored CUPS address matches client address.
          setUseClientAddress(true);
          setAddressLoadError(null);
        }

        if (useClientAddress) {
          await loadAddressIntoForm(partnerAddress);
        }
      } catch (error) {
        console.error("Error loading partner address:", error);
        setAddressLoadError(
          "Error al cargar la dirección del cliente. Por favor, recargue la página."
        );
      } finally {
        setLoadingAddress(false);
        setPartnerAddressLoaded(true);
      }
    };

    loadPartnerAddress();
  }, [oferta_erp, partnerAddressLoaded, useClientAddress, setValue, get_provincias, isCambioTitular]);

  const handleUseClientAddress = async (isChecked) => {
    if (isCambioTitular) {
      setUseClientAddress(false);
      return;
    }

    setUseClientAddress(isChecked);
    if (isChecked) {
      if (clientAddress) {
        setAddressLoadError(null);
        setLoadingAddress(true);
        try {
          await loadAddressIntoForm(clientAddress);
        } catch (err) {
          console.error("Error loading client address:", err);
          setAddressLoadError("Error al cargar la dirección del cliente.");
        } finally {
          setLoadingAddress(false);
        }
      } else {
        setAddressLoadError(
          "La dirección del cliente no está disponible todavía. Espere unos segundos e intente de nuevo."
        );
        setUseClientAddress(false);
      }
      return;
    }

    setAddressLoadError(null);
    clearAddressFields();
  };

  const cupsName = watch("cups_name");
  const currentCupsAddress = {
    cups_tv: watch("cups_tv"),
    cups_nv: watch("cups_nv"),
    cups_pt: watch("cups_pt"),
    cups_pu: watch("cups_pu"),
    cups_es: watch("cups_es"),
    cups_pnp: watch("cups_pnp"),
    cups_dp: watch("cups_dp"),
    cups_aclarador: watch("cups_aclarador"),
    cups_id_pais: 67,
    cups_id_provincia: watch("cups_id_provincia"),
    cups_id_municipi: watch("cups_id_municipi"),
    cups_id_poblacio: watch("cups_id_poblacio"),
  };

  const hasMissingAddressFields = hasMissingRequiredAddressFields(currentCupsAddress);
  const isErpAddressLockedBySubtype =
    isCupsInErp
    && (isRenewalSubtype || isAnyCambioTitularSubtype)
    && !hasMissingAddressFields;
  const addressReadOnly = useClientAddress || isErpAddressLockedBySubtype;

  const idPais = watch("cups_id_pais");
  const idProv = watch("cups_id_provincia");
  const idMuni = watch("cups_id_municipi");
  const cnaeDesc = watch("cnae_desc");

  const llistaPreuGlobal =
  oferta_erp?.llista_preu_global ||
  oferta_erp?.crm_polissa?.llista_preu_global ||
  oferta_erp?.crm_polissa?.llista_preu;

  //ANTIC
  // const hasAutoconsumo =
  //   autoconsumoValue !== null &&
  //   autoconsumoValue !== undefined &&
  //   String(autoconsumoValue).trim() !== "" &&
  //   String(autoconsumoValue) !== "00";
  // const showVirtualBattery =
  //   hasAutoconsumo && includesBvLabel(llistaPreuGlobal);

  //Només mostra card BV si autoconsumo es 41,42 o 43
  const autoconsumoValue = watch("autoconsumo_id") ?? oferta_erp?.autoconsumo ?? "";
  const hasAutoconsumo = autoconsumoValue === "41" || autoconsumoValue === "42" || autoconsumoValue === "43";
  const showVirtualBattery = (hasAutoconsumo && includesBvLabel(llistaPreuGlobal)) && !!oferta_erp?.bateria_virtual;

  const cupsOrigenName =
    cupsName || oferta_erp?.cups_name || oferta_erp?.cups_global || "";
  const hasErpCupsAddress = hasAddressData(erpCupsAddressRef.current);
  const erpAddressMismatch =
    isCupsInErp
    && !addressReadOnly
    && hasErpCupsAddress
    && !addressesMatch(currentCupsAddress, erpCupsAddressRef.current);
  const cupsAddressMatchesClient =
    !isCambioTitular && !!clientAddress && addressesMatch(currentCupsAddress, clientAddress);
  const gasDistribuidoraName =
    watch("cups_distribuidora_name")
    || distribuidorasGas?.find((d) => String(d?.id) === String(watch("cups_distribuidora_id")))?.name
    || "";
  const canEditElectricDistribuidoraName =
    sector_type === "electrico"
    && !isFieldReadOnly("cups_distribuidora_name")
    && !watch("cups_distribuidora_id")
    && (gasDistribuidoraSource === "none" || gasDistribuidoraSource === "manual");
  const canEditGasDistribuidoraName =
    sector_type === "gas"
    && !isFieldReadOnly("cups_distribuidora_id")
    && !watch("cups_distribuidora_id")
    && !gasDistribuidoraName
    && !!String(cupsName || oferta_erp?.cups_name || oferta_erp?.cups_global || "").trim();

  useEffect(() => {
    if (isCupsInErp && !isErpAddressLockedBySubtype && useClientAddress) {
      setUseClientAddress(false);
    }
  }, [isCupsInErp, isErpAddressLockedBySubtype, useClientAddress]);

  const onSubmit = useCallback(async () => {
    const elec = oferta_erp.sector_type === "electrico";
    const data = getValues();
    const tipus = "oferta";

    const potencias = {};
    if (elec && data.potencias) {
      Object.entries(data.potencias).forEach(([key, value]) => {
        if (value && typeof value === 'string' && value.trim() !== '') {
          // Limpiar valor: quitar miles, usar punto decimal
          const cleanedValue = value.replace(/\./g, '').replace(',', '.');
          const floatVal = parseFloat(cleanedValue);

          if (!isNaN(floatVal)) {
            // Enviar como número float, con 3 decimales
            potencias[key] = parseFloat(floatVal.toFixed(3));
          } else {
            potencias[key] = null;
          }
        } else {
          potencias[key] = null;
        }
      });
    }

    // 👉 Obtener el valor máximo de las potencias
    const potenciasValidas = Object.values(potencias).filter((v) => typeof v === "number" && !isNaN(v));
    const potenciaMaxima = potenciasValidas.length > 0 ? Math.max(...potenciasValidas) : null;

    const datosCups = {
      cups_name: data.cups_name,
      cups_ref_catastral: data.cups_ref_catastral,
      cups_id_pais: 67,
      cups_id_provincia: data.cups_id_provincia,
      cups_id_municipi: data.cups_id_municipi,
      cups_id_poblacio: Number(data.cups_id_poblacio),
      cups_aclarador: data.cups_aclarador,
      cups_tv: data.cups_tv,
      cups_nv: data.cups_nv,
      cups_pt: data.cups_pt,
      cups_pu: data.cups_pu,
      cups_es: data.cups_es,
      cups_pnp: data.cups_pnp,
      cups_dp: data.cups_dp,
      [elec ? "cnae" : "cnae_gas"]: data.cnae,
      [elec ? "cups_distribuidora_id" : "cups_gas_distribuidora_id"]: data.cups_distribuidora_id,
      [elec ? "cups_distribuidora_name" : "cups_gas_distribuidora_name"]: data.cups_distribuidora_name,
    };
    const dataOferta = elec
      ? {
        ...datosCups,
        autoconsumo: data.autoconsumo_id,
        //consumo_anual_previsto: data.consumo_anual_previsto,
        consumo_anual_previsto_directo: data.consumo_anual_previsto,
        potencia_ofertada: potenciaMaxima,
        potencia_client: potenciaMaxima,
      }
      : {
        ...datosCups,
        // caudal_diario: data.caudal_diario,
        consumo_anual_gas_previsto_directo: data.consumo_anual_previsto,
        // pressio_cups: data.pressio_cups,
      };
    const dataCups = {
      ...datosCups,
      sector_type: sector_type,
      cups_global: data.cups_name,
      cups_cpo: null,
      cups_cpa: null,
    };
    let cup = {};
    try {
      if (oferta_erp.cups_id) {
        cup = await set_cups_erp(oferta_erp.cups_id[0], dataCups);
      } else {
        let params = { dataCups };
        if (elec) {
          params.oferta_id = oferta_erp.id;
          params.tarifa_oferta = oferta_erp.tarifa_oferta[0];
        }
        cup = await find_or_create_cups(params);
      }
      dataOferta[elec ? "cups_id" : "cups_gas_id"] = cup.cups_id ?? cup.id;
      dataOferta.cups_global = data.cups_name;
      const oferta = await set_oferta_erp(
        oferta_erp.id,
        dataOferta,
        oferta_erp.sector_type,
        oferta_erp?.sub_type_offer,
        oferta_erp?.cliente_vat
      );
      if (elec) {
        await generar_precios(
          oferta_erp.id,
          tipus,
          oferta_erp.llista_preu[0],
          potencias
        );
      }
      if (showVirtualBattery) {
        navigate(
          `/${sector_type}/bateria-virtual/${oferta_erp.id}`,
          {
            state: { editMode: editMode || false },
          }
        );
        return { preventDefaultNavigation: true };
      }
      // Else let Wizard handle navigation to Documentation
      toast.success("Datos del suministro guardados correctamente.", { position: toast.POSITION.TOP_CENTER });
    } catch (error) {
      console.error("Error al guardar datos del suministro:", error);
      toast.error("Error al guardar los datos del suministro. Inténtelo de nuevo.", { position: toast.POSITION.TOP_CENTER, autoClose: false });
    }
  }, [
    oferta_erp,
    getValues,
    sector_type,
    navigate,
    showVirtualBattery,
    set_cups_erp,
    find_or_create_cups,
    set_oferta_erp,
    generar_precios,
  ]);

  // Register wizard actions
  useEffect(() => {
    setActionHandler({
      onNext: () => handleSubmit(onSubmit)(),
      onSave: () => handleSubmit(async () => {
        await onSubmit();
      })()
    });
  }, [setActionHandler, handleSubmit, onSubmit]);

  const changeCnae = (value) => {
    let cnaeDesc = cnaes.find((c) => c.name === value);
    if (cnaeDesc) {
      cnaeDesc = cnaeDesc.descripcio;
    } else {
      cnaeDesc = "No existe el CNAE";
    }
    setValue("cnae_desc", cnaeDesc);
  };
  return (

    <div className="py-4">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <Card className="detail-card border-0 shadow-lg rounded-4 overflow-hidden">
              <Card.Header className="bg-white border-bottom-0 pt-4 pb-0 text-center">
                <h2 className="text-primary fw-bold mb-0">Datos del Punto de Suministro</h2>
              </Card.Header>
              <Card.Body className="p-4 p-md-5">
                {sipsWarning && (
                  <div className="alert alert-warning mb-4 shadow-sm border-0 d-flex align-items-center">
                    <i className="bi bi-exclamation-triangle-fill me-3 fs-4"></i>
                    <div>
                      <h6 className="mb-1 fw-bold">Aviso de Tarifa SIPS</h6>
                      <p className="mb-0 small">{sipsWarning}</p>
                    </div>
                  </div>
                )}

                {activeContractWarning && (
                  <div className="alert alert-danger mb-4 shadow-sm border-0 d-flex align-items-center">
                    <i className="bi bi-shield-lock-fill me-3 fs-4"></i>
                    <div>
                      <h6 className="mb-1 fw-bold">Contrato Activo Detectado</h6>
                      <p className="mb-0 small">{activeContractWarning}</p>
                    </div>
                  </div>
                )}

                {sipsBusinessWarnings.length > 0 && (
                  <div className="alert alert-warning mb-4 shadow-sm border-0 d-flex align-items-start">
                    <i className="bi bi-exclamation-circle-fill me-3 fs-4"></i>
                    <div>
                      <h6 className="mb-2 fw-bold">Revisión funcional SIPS</h6>
                      {sipsBusinessWarnings.map((warning, idx) => (
                        <p key={`${warning}-${idx}`} className="mb-1 small">{warning}</p>
                      ))}
                    </div>
                  </div>
                )}

                <Form onSubmit={handleSubmit(onSubmit)}>
                  {/* Section: CUPS & Consumption */}
                  <div className="bg-light p-4 rounded-4 border border-light mb-4">
                    <h5 className="fw-bold text-secondary mb-3">Información del CUPS</h5>
                    <Row className="g-3">
                      <Col lg={7} md={12}>
                        <Row className="g-3 align-items-end">
                          <Col lg={9} md={8}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">CUPS</label>
                            <Controller
                              name="cups_name"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={isFieldReadOnly("cups_name")}
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                          {!isRenewalSubtype && (
                            <Col lg={3} md={4}>
                              <Button
                                type="button"
                                disabled={cupsName?.length < 20 || isFieldReadOnly("cups_name") || isSearchingCups}
                                variant="primary"
                                className="rounded-pill fw-bold shadow-sm py-2 px-3"
                                onClick={onSearchCups}
                                style={{ whiteSpace: 'nowrap' }}
                              >
                                {isSearchingCups ? "Buscando..." : "Buscar"}
                              </Button>
                            </Col>
                          )}
                          {isRenewalSubtype && (
                            <Col lg={12}>
                              <small className="text-muted d-block mt-2">
                                En renovaciones no se requiere búsqueda SIPS; los datos de suministro se toman del contrato activo.
                              </small>
                            </Col>
                          )}
                        </Row>
                      </Col>
                      <Col lg={5} md={12}>
                        <label className="text-muted small fw-bold text-uppercase mb-2">
                          Consumo Anual ({sector_type === "electrico" ? "KWh" : "KWh"})
                        </label>
                        <Controller
                          name="consumo_anual_previsto"
                          control={control}
                          render={({ field, fieldState: { error } }) => (
                            <TextInput
                              {...field}
                              noFloating={true}
                              error={error?.message}
                              readOnly={isFieldReadOnly("consumo_anual_previsto")}
                              className="bg-white shadow-sm"
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Section: Autoconsumo & Distribuidora */}
                  <div className="bg-light p-4 rounded-4 border border-light mb-4">
                    <Row className="g-3">
                      {sector_type === "electrico" && (
                        <Col md={6}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Autoconsumo</label>
                          <Controller
                            name="autoconsumo_id"
                            control={control}
                            render={({ field, fieldState: { error } }) => {
                              if (isFieldReadOnly("autoconsumo_id") && !isAutoconsumoChangeSubtype) {
                                const selectedLabel =
                                  autoconsumoFallbackOption?.id === field.value
                                    ? autoconsumoFallbackOption.name
                                    : (autoconsumos.find((a) => a.id === field.value)?.name ?? field.value ?? "");
                                return (
                                  <Form.Control
                                    value={selectedLabel}
                                    readOnly
                                    placeholder="Sin autoconsumo"
                                    className="bg-white shadow-sm"
                                  />
                                );
                              }
                              return (
                                <SelectInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  className="bg-white shadow-sm"
                                >
                                  <option value="" disabled>Seleccione autoconsumo</option>
                                  {autoconsumoFallbackOption && (
                                    <option value={autoconsumoFallbackOption.id}>
                                      {autoconsumoFallbackOption.name}
                                    </option>
                                  )}
                                  {autoconsumos?.map((autoconsumo) => (
                                    <option key={autoconsumo.id} value={autoconsumo.id}>
                                      {autoconsumo.name}
                                    </option>
                                  ))}
                                </SelectInput>
                              );
                            }}
                          />
                        </Col>
                      )}
                      <Col md={sector_type === "electrico" ? 6 : 12}>
                        <label className="text-muted small fw-bold text-uppercase mb-2">Distribuidora</label>
                        <Controller
                          name="cups_distribuidora_name"
                          control={control}
                          render={({ field, fieldState: { error } }) => (
                            <>
                              {sector_type === "electrico" ? (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={!canEditElectricDistribuidoraName}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    if (canEditElectricDistribuidoraName) {
                                      setValue("cups_distribuidora_id", "", { shouldValidate: true, shouldDirty: true });
                                      setGasDistribuidoraSource("manual");
                                    }
                                  }}
                                  className="bg-white shadow-sm"
                                />
                              ) : gasDistribuidoraName && isFieldReadOnly("cups_distribuidora_id") ? (
                                <TextInput
                                  value={gasDistribuidoraName}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly
                                  className="bg-white shadow-sm"
                                />
                              ) : canEditGasDistribuidoraName ? (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={false}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    setValue("cups_distribuidora_id", "", { shouldValidate: true, shouldDirty: true });
                                    setGasDistribuidoraSource("manual");
                                  }}
                                  className="bg-white shadow-sm"
                                />
                              ) : (
                                <Controller
                                  name="cups_distribuidora_id"
                                  control={control}
                                  render={({ field: distField, fieldState: { error: distError } }) => (
                                    <SelectInput
                                      {...distField}
                                      noFloating={true}
                                      error={distError?.message}
                                      onChange={(e) => {
                                        const newId = e.target.value;
                                        distField.onChange(newId);
                                        const selected = distribuidorasGas?.find((dist) => String(dist.id) === String(newId));
                                        setValue("cups_distribuidora_name", selected?.name || "", { shouldValidate: true, shouldDirty: true });
                                        setGasDistribuidoraSource("manual");
                                      }}
                                      disabled={isFieldReadOnly("cups_distribuidora_id")}
                                      className="bg-white shadow-sm"
                                    >
                                      <option value="" disabled>Seleccione distribuidora</option>
                                      {!!distField.value && !hasOptionById(distribuidorasGas, distField.value) && (
                                        <option value={distField.value}>{gasDistribuidoraName || `Distribuidora (${distField.value})`}</option>
                                      )}
                                      {distribuidorasGas?.map((dist) => (
                                        <option key={dist.id} value={dist.id}>
                                          {dist.name}
                                        </option>
                                      ))}
                                    </SelectInput>
                                  )}
                                />
                              )}
                            </>
                          )}
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Section: SIPS technical data (electricity only) */}
                  {sector_type === "electrico" && (
                    <div className="bg-light p-4 rounded-4 border border-light mb-4">
                      <h5 className="fw-bold text-secondary mb-3">Datos técnicos SIPS</h5>
                      <Row className="g-3">
                        <Col md={4}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Tarifa de Acceso SIPS</label>
                          <Form.Control
                            value={CODIGOS_TARIFA_ATR[sipsTarifaAcceso] || sipsTarifaAcceso || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className={`bg-white shadow-sm ${sipsTarifaAcceso && oferta_erp?.tarifa_oferta?.[1] && !areTarifasAccesoCompatible(sipsTarifaAcceso, oferta_erp.tarifa_oferta[1]) ? "border-warning" : ""}`}
                          />
                          {sipsTarifaAcceso && oferta_erp?.tarifa_oferta?.[1] && !areTarifasAccesoCompatible(sipsTarifaAcceso, oferta_erp.tarifa_oferta[1]) && (
                            <small className="text-warning fw-bold d-block mt-1">
                              <i className="bi bi-exclamation-triangle-fill me-1"></i>
                              Tarifa actualizada por SIPS. Puede ser incompatible con la tarifa comercial seleccionada.
                            </small>
                          )}
                        </Col>
                        <Col md={4}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Potencia Máxima BIE</label>
                          <Form.Control
                            value={sipsTechnicalData?.potencia_maxima_bie || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className="bg-white shadow-sm"
                          />
                        </Col>
                        <Col md={4}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Caducidad BIE</label>
                          <Form.Control
                            value={sipsTechnicalData?.fecha_caducidad_bie || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className="bg-white shadow-sm"
                          />
                        </Col>
                        <Col md={4}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Valor Derechos Extensión</label>
                          <Form.Control
                            value={sipsTechnicalData?.valor_derechos_extension || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className="bg-white shadow-sm"
                          />
                        </Col>
                        <Col md={6}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Tipo Autoconsumo (pendiente revisión)</label>
                          <Form.Control
                            value={sipsTechnicalData?.tipo_autoconsumo_sips || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className="bg-white shadow-sm"
                          />
                        </Col>
                        <Col md={6}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Aplicación Bono Social (pendiente revisión)</label>
                          <Form.Control
                            value={sipsTechnicalData?.aplicacion_bono_social_sips || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className="bg-white shadow-sm"
                          />
                        </Col>
                        <Col md={6}>
                          <label className="text-muted small fw-bold text-uppercase mb-2">Perfil de Consumo SIPS</label>
                          <Form.Control
                            value={sipsTechnicalData?.tipo_perfil_consumo_sips || ""}
                            readOnly
                            placeholder="Sin datos SIPS"
                            className="bg-white shadow-sm"
                          />
                        </Col>
                      </Row>
                      <small className="text-muted d-block mt-2">
                        Estos datos se consultan por API SIPS y no bloquean la continuidad del flujo si no están disponibles.
                      </small>
                    </div>
                  )}

                  {/* Section: SIPS technical data (gas only) */}
                  {sector_type === "gas" && sipsGasTechnicalData && (
                    <div className="bg-light p-4 rounded-4 border border-light mb-4">
                      <h5 className="fw-bold text-secondary mb-3">Datos técnicos SIPS (Gas)</h5>
                      <Row className="g-3">
                        {sipsGasTechnicalData.caudal_horario && (
                          <Col md={4}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Caudal Horario (Wh)</label>
                            <Form.Control
                              value={sipsGasTechnicalData.caudal_horario}
                              readOnly
                              className="bg-white shadow-sm"
                            />
                          </Col>
                        )}
                        {sipsGasTechnicalData.caudal_maximo_diario && (
                          <Col md={4}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Caudal Máximo Diario (Wh)</label>
                            <Form.Control
                              value={sipsGasTechnicalData.caudal_maximo_diario}
                              readOnly
                              className="bg-white shadow-sm"
                            />
                          </Col>
                        )}
                        {sipsGasTechnicalData.codigo_presion && (
                          <Col md={4}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Código de Presión</label>
                            <Form.Control
                              value={sipsGasTechnicalData.codigo_presion}
                              readOnly
                              className="bg-white shadow-sm"
                            />
                          </Col>
                        )}
                      </Row>
                      <small className="text-muted d-block mt-2">
                        Datos técnicos obtenidos de SIPS. Solo informativos.
                      </small>
                    </div>
                  )}

                  {/* Section: Potencias (solo eléctrico) */}
                  {sector_type === "electrico" && (
                    <PotenciasInput
                      control={control}
                      errors={errors}
                      watch={watch}
                      regexpPotencia={regexpPotencia}
                      readOnly={isFieldReadOnly("potencias")}
                    />
                  )}

                  {/* Section: CNAE */}
                  <div className="bg-light p-4 rounded-4 border border-light mb-4">
                    <h5 className="fw-bold text-secondary mb-3">CNAE</h5>
                    <Row className="g-3">
                      <Col lg={2} md={4}>
                        <label className="text-muted small fw-bold text-uppercase mb-2">CNAE</label>
                        <Controller
                          name="cnae"
                          control={control}
                          render={({ field, fieldState: { error } }) => (
                            <>
                              <TextInput
                                {...field}
                                noFloating={true}
                                error={error?.message}
                                readOnly={isFieldReadOnly("cnae")}
                                disabled={isFieldReadOnly("cnae")}
                                onFocus={() => {
                                  if (isFieldReadOnly("cnae")) return;
                                  getSuggestions(""); 
                                }}
                                onBlur={() => {
                                  setTimeout(() => setSuggestions([]), 150);
                                }}
                                onChange={(e) => {
                                  if (isFieldReadOnly("cnae")) return;
                                  const nextValue = e.target.value;
                                  setValue("cnae", nextValue, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                  });
                                  changeCnae(nextValue);
                                  getSuggestions(nextValue);
                                }}
                                className="bg-white shadow-sm"
                              />
                              {suggestions.length > 0 && (
                                <div className="position-absolute bg-white border rounded shadow-sm w-100 z-3" 
                                  style={{
                                    maxHeight: "300px",
                                    maxWidth: "700px",
                                    overflowY: "auto"
                                  }}>
                                  {suggestions.map((cnae) => (
                                    <div key={cnae.name}
                                      className="p-2 hover-bg-light"
                                      onClick={() => elegirSuggestio(cnae)}>
                                      {cnae.name} — {cnae.descripcio}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </>
                          )}
                        />
                      </Col>
                      <Col lg={10} md={8}>
                        <label className="text-muted small fw-bold text-uppercase mb-2">Descripción</label>
                        <Form.Control
                          value={cnaeDesc || ""}
                          className="form-control bg-white shadow-sm"
                          placeholder="Descripción del CNAE"
                          type="text"
                          readOnly
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Section: Ref. Catastral */}
                  <div className="bg-light p-4 rounded-4 border border-light mb-4">
                    <Row className="g-3">
                      <Col lg={6} md={12}>
                        <label className="text-muted small fw-bold text-uppercase mb-2">Ref. Catastral</label>
                        <Controller
                          name="cups_ref_catastral"
                          control={control}
                          render={({ field, fieldState: { error } }) => (
                            <TextInput
                              {...field}
                              noFloating={true}
                              error={error?.message}
                              readOnly={refCatastralReadOnly}
                              className="bg-white shadow-sm"
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Section: Different Address Checkbox */}
                  {!isCambioTitular && !isCupsInErp && (
                    <div className="bg-light p-4 rounded-4 border border-light mb-4">
                      <Row className="g-3">
                        <Col md={12}>
                          {loadingAddress && (
                            <div className="alert alert-info mb-3 py-2 px-3 d-flex align-items-center">
                              <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                              <span className="mb-0 small">
                                <strong>Cargando dirección...</strong> - Por favor espere
                              </span>
                            </div>
                          )}
                          {addressLoadError && (
                            <div className="alert alert-danger mb-3 py-2 px-3 d-flex align-items-center">
                              <i className="bi bi-exclamation-triangle-fill me-2"></i>
                              <span className="mb-0 small">
                                <strong>Error:</strong> {addressLoadError}
                              </span>
                            </div>
                          )}
                          {useClientAddress && clientAddress && !loadingAddress && (
                            <div className="alert alert-info mb-3 py-2 px-3 d-flex align-items-center">
                              <i className="bi bi-check-circle-fill me-2"></i>
                              <span className="mb-0 small">
                                <strong>Usando dirección del cliente</strong> - Los datos se han precargado automáticamente
                              </span>
                            </div>
                          )}
                          {!loadingAddress && clientAddress && !useClientAddress && (
                            <div className={`alert mb-3 py-2 px-3 d-flex align-items-center ${cupsAddressMatchesClient ? "alert-success" : "alert-warning"}`}>
                              <i className={`bi me-2 ${cupsAddressMatchesClient ? "bi-check2-circle" : "bi-exclamation-circle"}`}></i>
                              <span className="mb-0 small">
                                {cupsAddressMatchesClient
                                  ? "La dirección del CUPS coincide con la del cliente. Puede marcar el check para usarla automáticamente."
                                  : "La dirección del CUPS NO coincide con la del cliente. Revise los datos antes de continuar."}
                              </span>
                            </div>
                          )}
                          <Form.Check
                            type="checkbox"
                            id="useClientAddress"
                            label={
                              <span className="fw-bold text-secondary">
                                Si la dirección del CUPS es la misma que la del cliente, marque aquí
                              </span>
                            }
                            onChange={(e) => handleUseClientAddress(e.target.checked)}
                            checked={useClientAddress}
                            className="mb-0 custom-checkbox"
                            disabled={loadingAddress}
                          />
                          {!useClientAddress && (
                            <small className="text-muted d-block mt-2">
                              Complete manualmente la dirección del CUPS.
                            </small>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* Section: Dirección y Ubicación Geográfica */}
                  {isCupsInErp && (
                    <div className={`alert mb-4 py-2 px-3 d-flex align-items-center ${isErpAddressLockedBySubtype ? "alert-success" : "alert-info"}`}>
                      <i className={`bi me-2 ${isErpAddressLockedBySubtype ? "bi-database-fill-check" : "bi-info-circle-fill"}`}></i>
                      <span className="mb-0 small">
                        {isErpAddressLockedBySubtype
                          ? <><strong>CUPS encontrado en el ERP</strong> - La dirección del punto de suministro se ha cargado automáticamente y está bloqueada para este subtipo.</>
                          : <><strong>CUPS encontrado en el ERP</strong> - Se ha precargado la dirección del punto de suministro, pero puedes editarla para este subtipo.</>}
                      </span>
                    </div>
                  )}

                  {erpAddressMismatch && (
                    <div className="alert alert-warning mb-4 py-2 px-3 d-flex align-items-center">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      <span className="mb-0 small">
                        <strong>La dirección no coincide con ERP</strong> - Los datos actuales del formulario difieren de la dirección guardada en base de datos para este CUPS.
                      </span>
                    </div>
                  )}

                  {/* Section: Dirección y Ubicación Geográfica */}
                  <AddressFields
                    control={control}
                    errors={errors}
                    paises={paises}
                    provincias={provincias}
                    municipios={municipios}
                    poblaciones={poblaciones}
                    tipovia={tipovia}
                    loadingProv={loadingProv}
                    loadingMuni={loadingMuni}
                    loadingPob={loadingPob}
                    idPais={idPais}
                    idProv={idProv}
                    idMuni={idMuni}
                    onPaisChange={fetchProvincias}
                    onProvinciaChange={fetchMunicipios}
                    onMunicipioChange={fetchPoblaciones}
                    prefix="cups_"
                    watchCountry="cups_id_pais"
                    watchProvince="cups_id_provincia"
                    watchMunicipio="cups_id_municipi"
                    watchPoblacion="cups_id_poblacio"
                    noFloating={true}
                    readOnly={isAddressFieldReadOnly}
                    prefillLabels={addressPrefillLabels}
                  />
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const OfertaCups = (props) => {
  const { sector_type, oferta_id } = useParams();
  return (
    <Layout
      offerContext={{ sector_type, oferta_id }}
    >
      <OfferWizardWrapper currentStep="cups">
        <OfertaCupsForm {...props} />
      </OfferWizardWrapper>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  paises: state.Auxiliares.paises,
  provincias: state.Auxiliares.provincias,
  municipios: state.Auxiliares.municipios,
  poblaciones: state.Auxiliares.poblaciones,
  tipovia: state.Auxiliares.tipovia,
  distribuidorasGas: state.Auxiliares.distribuidorasGas,
  cnaes: state.Auxiliares.cnaes,
});

export default connect(mapStateToProps, {
  get_paises,
  get_provincias,
  get_municipios,
  get_poblaciones,
  get_tipovia,
  get_distribuidoras_gas,
  get_cnaes,
  setLoader,
  removeLoader,
})(OfertaCups);
